class FetchApi {
  async fetchGetApi () {
    // eslint-disable-next-line no-undef
    const res = await fetch('https://juan-lopez-87.firebaseio.com/.json')
    if (res.ok) {
      const data = res.json()
      return { data, status: true }
    } else {
      return { data: {}, status: false }
    }
  }
}

export default FetchApi
